import MDBox from "components/MDBox";
import React from "react";
import { useState } from "react";
import useStyles from "./styles";
import clsx from "clsx";

const Tab = ({ tab, selected, onClick }) => {
  const classes = useStyles();
  return (
    <div className={clsx(classes.tabBase, selected && classes.tabActive)} onClick={onClick}>
      {tab.title}
    </div>
  );
};

export default function TabView({ tabs }) {
  const [selectedTab, setSelectedTab] = useState(tabs.length > 0 ? 0 : null);
  const changeTab = (selected) => {
    setSelectedTab(selected);
  };
  return (
    selectedTab != null && (
      <MDBox>
        <MDBox display="flex" px={2}>
          {tabs.map((tab, index) => (
            <Tab
              key={index}
              tab={tab}
              selected={index === selectedTab}
              onClick={() => changeTab(index)}
            />
          ))}
        </MDBox>
        <MDBox>{tabs[selectedTab].component}</MDBox>
      </MDBox>
    )
  );
}
